import React from 'react';
import { connect } from 'react-redux';
import { goToStep, confirmReview } from 'actions/kyb';
import * as clevertapKyb from 'clevertap/kyb';
import styles from './PreviewKyb.css';

const PreviewKyb = class PreviewKyb extends React.Component {
  componentDidMount() {
    const {
      phone,
      email,
      business: {
        business_category_id: businessCategory,
        province: businessLocation,
      },
    } = this.props.data.moka.user;
    const {
      business_entity_type: businessEntityType,
      address,
      city,
      kecamatan,
      name: businessName,
      province,
      postal_code: postalCode,
    } = this.props.data.kybForm.kybData;
    const {
      KTP_NAME: NameOnID,
      KTP_NUMBER: IDNumber,
    } = this.props.data.kybForm.kybIdentity;
    const {
      account_holder_name: bankAccountName,
      account_holder_number: bankAcountNumber,
      bank_id: bankId,
    } = this.props.data.kybForm.kybBankData;
    const bank = this.props.bankListState.find(function(bank) {
      return bank.id === bankId;
    });
    const clevertapData = {
      email,
      phone,
      businessCategory,
      businessLocation,
      businessEntityType,
      address,
      city,
      kecamatan,
      businessName,
      province,
      postalCode,
      isKTPPhotoUploaded: true,
      NameOnID,
      IDNumber,
      bankName: bank.name,
      bankAccountName,
      bankAcountNumber,
    };
    this.props.appendBusinessOpeningClevertap(clevertapData);
    clevertapKyb.clevertapTracker('KYB Review Details', clevertapData);
  }

  goBack = () => {
    this.props.dispatch(goToStep(4));
  };

  handleConfirm = () => {
    this.props.dispatch(confirmReview());
    const {
      phone,
      email,
      business: {
        business_category_id: businessCategory,
        province: businessLocation,
      },
    } = this.props.data.moka.user;
    const {
      business_entity_type: businessEntityType,
      address,
      city,
      kecamatan,
      name: businessName,
      province,
      postal_code: postalCode,
    } = this.props.data.kybForm.kybData;
    const {
      KTP_NAME: NameOnID,
      KTP_NUMBER: IDNumber,
    } = this.props.data.kybForm.kybIdentity;
    const {
      account_holder_name: bankAccountName,
      account_holder_number: bankAcountNumber,
      bank_id: bankId,
    } = this.props.data.kybForm.kybBankData;
    const bank = this.props.bankListState.find(function(bank) {
      return bank.id === bankId;
    });
    const clevertapData = {
      email,
      phone,
      businessCategory,
      businessLocation,
      businessEntityType,
      address,
      city,
      kecamatan,
      businessName,
      province,
      postalCode,
      isKTPPhotoUploaded: true,
      NameOnID,
      IDNumber,
      bankName: bank.name,
      bankAccountName,
      bankAcountNumber,
    };
    this.props.appendBusinessOpeningClevertap(clevertapData);
    clevertapKyb.clevertapTracker('KYB Completed', clevertapData);
  };

  render() {
    const {
      email,
      first_name: firstName,
      last_name: lastName,
      phone,
    } = this.props.data.moka.user;
    const kybData = this.props.data.kybForm.kybData || {};
    const {
      address,
      name,
      province,
      city,
      kecamatan,
      postal_code: postalCode,
    } = kybData;
    const { kybBankData, kybIdentity } = this.props.data.kybForm;
    const bank = this.props.bankListState.find(function(bank) {
      return bank.id === kybBankData.bank_id;
    });
    return (
      <div className={`${styles.preview}`}>
        <div className="col-md-10 col-md-offset-1">
          <h2 className={`${styles['preview-heading']}`}>Review Details</h2>
          <div className={`${styles['sub-heading']}`}>
            <h2>PERSONAL DETAILS</h2>
          </div>
          <div className={`${styles.fields}`}>
            <p className={`${styles.key}`}>Name</p>
            <p className={`${styles.value}`}>{`${firstName} ${
              lastName !== null ? lastName : ''
            }`}</p>
          </div>
          <div className={`${styles.fields}`}>
            <p className={`${styles.key}`}>Phone</p>
            <p className={`${styles.value}`}>{phone}</p>
          </div>
          <div className={`${styles.fields}`}>
            <p className={`${styles.key}`}>Email</p>
            <p className={`${styles.value}`}>{email}</p>
          </div>
          <br />
          <br />
          <div className={`${styles['sub-heading']}`}>
            <h2>BUSINESS INFO</h2>
            <p
              className={`${styles.edit}`}
              onClick={() => this.props.dispatch(goToStep(2, true))}
            >
              Edit
            </p>
          </div>
          <div className={`${styles.fields}`}>
            <p className={`${styles.key}`}>Business Name</p>
            <p className={`${styles.value}`}>{name}</p>
          </div>
          <div className={`${styles.fields}`}>
            <p className={`${styles.key}`}>Business Address</p>
            <p className={`${styles.value}`}>{address}</p>
          </div>
          <div className={`${styles.fields}`}>
            <p className={`${styles.key}`}>Province</p>
            <p className={`${styles.value}`}>{province}</p>
          </div>
          <div className={`${styles.fields}`}>
            <p className={`${styles.key}`}>City/Kabupaten</p>
            <p className={`${styles.value}`}>{city}</p>
          </div>
          <div className={`${styles.fields}`}>
            <p className={`${styles.key}`}>Kecamatan</p>
            <p className={`${styles.value}`}>{kecamatan}</p>
          </div>
          <div className={`${styles.fields}`}>
            <p className={`${styles.key}`}>Postal Code</p>
            <p className={`${styles.value}`}>{postalCode}</p>
          </div>
          <br />
          <br />
          <div className={`${styles['sub-heading']}`}>
            <h2>ID</h2>
            <p
              className={`${styles.edit}`}
              onClick={() => this.props.dispatch(goToStep(3, true))}
            >
              Edit
            </p>
          </div>
          <div className={`${styles.fields}`}>
            <p className={`${styles.key}`}>Name</p>
            <p className={`${styles.value}`}>{kybIdentity.KTP_NAME}</p>
          </div>
          <div className={`${styles.fields}`}>
            <p className={`${styles.key}`}>ID Photo</p>
            <p className={`${styles.value}`}>
              <img src={kybIdentity.IMAGE_URL} title="ID" width="80px" />
            </p>
          </div>
          <div className={`${styles.fields}`}>
            <p className={`${styles.key}`}>ID Number</p>
            <p className={`${styles.value}`}>{kybIdentity.KTP_NUMBER}</p>
          </div>
          <br />
          <br />
          <div className={`${styles['sub-heading']}`}>
            <h2>BANK ACCOUNT</h2>
            <p
              className={`${styles.edit}`}
              onClick={() => this.props.dispatch(goToStep(4, true))}
            >
              Edit
            </p>
          </div>
          <div className={`${styles.fields}`}>
            <p className={`${styles.key}`}>Name</p>
            <p className={`${styles.value}`}>
              {kybBankData.account_holder_name}
            </p>
          </div>
          <div className={`${styles.fields}`}>
            <p className={`${styles.key}`}>Bank Name</p>
            <p className={`${styles.value}`}>{bank.name}</p>
          </div>
          <div className={`${styles.fields}`}>
            <p className={`${styles.key}`}>Account Number</p>
            <p className={`${styles.value}`}>
              {kybBankData.account_holder_number}
            </p>
          </div>
        </div>
        <div className={`col-md-10 col-md-offset-1 ${styles['flex-display']}`}>
          <div className={`col-md-6 col-sm-6 col-xs-6 ${styles['form-btn']}`}>
            <button
              className={`btn btn-block btn-default ${styles['back-btn']}`}
              type="button"
              onClick={() => this.props.dispatch(goToStep(4))}
            >
              Back
            </button>
          </div>
          <div className={`col-md-6 col-sm-6 col-xs-6 ${styles['form-btn']}`}>
            <button
              className={`btn btn-primary btn-block`}
              type="button"
              onClick={this.handleConfirm}
            >
              Confirm Details
            </button>
          </div>
        </div>
        <div className="col-md-10 col-md-offset-1">
          <p className={`${styles.terms}`}>
            By submitting this application, you agree to our{' '}
            <b>
              <a
                href="https://www.mokapos.com/terms"
                target="_blank"
                className={styles.link}
              >
                Terms of Service
              </a>
            </b>{' '}
            and acknowledge that there will be a transaction fee applied to your
            transactions.
          </p>
        </div>
      </div>
    );
  }
};

function select(state) {
  return {
    data: state,
  };
}

export default connect(select)(PreviewKyb);
